import { Styles } from 'react-modal'
import styled from 'styled-components'
export const stylesModal: Styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
    },
    content: {
        position: 'absolute',
        inset: 'auto',
        border: '1px solid #ccc',
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '16px',
        outline: 'none',
        padding: '0px',
        width: '100%',
        height: '100%',
        maxHeight: '488px',
        maxWidth: '424px',
    },
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
    background-color: #ffffffff;
`

export const HeaderModal = styled.div`
    display: flex;
    width: 100%;

    padding-top: 32px;
    padding-right: 32px;
    justify-content: flex-end;

    button {
        border: 0;
        background: transparent;
        cursor: pointer;
    }
`
